import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import {useIdleTimer} from 'react-idle-timer'

const App = () => {
  const {logout} = useAuth()

  const onIdle = () => {
    if (window.location.pathname !== '/auth') {
      logout()

      window.location.href = '/auth'
    }
  }

  const {reset} = useIdleTimer({
    timeout: 1000 * 60 * 5, // 5 minutos
    onIdle,
    debounce: 500,
  })

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
